import { h, render, Component } from 'preact';
import SmoothTable from './SmoothTable.jsx';

const tableData = (() => {
  return {
    headers: [
      'Name',
      'Price',
      'NetAssetsMktCap'
    ],
    rows: Array(50).fill(1).map((i) => [
      { name: 'Apple', ticker: 'AAPL', securityType: 'Stock', secondaryType: 'Common', url: '/stocks/financials/banking/banks/aapl-apple-inc/' },
      { priceAmount: 27.20, priceCurrency: 'USD', priceMovement: '-0.67%' },
      { amount: 59.55, currency: 'USD' }
    ])
  };
})();

class BDCPortfolioPageTable extends Component {

  componentDidMount() {
    this.setState({
      tableData
    });
  }

  render() {
    return <SmoothTable data={this.state.tableData} />;
  }
}

export default BDCPortfolioPageTable;
